// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f29a1206","455":"59aec5d5","977":"ed16a76b"}[chunkId] + ".chunk.js";
};